var map = {
	"./option-1.css": [
		9048,
		48
	],
	"./option-2.css": [
		5180,
		180
	],
	"./option-3.css": [
		7653,
		653
	],
	"./option-4.css": [
		3496,
		496
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1059;
module.exports = webpackAsyncContext;